import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-project-summary-stretch-goal",
  "data-qa": "project-summary-stretch-goal"
}
const _hoisted_2 = { class: "gfu-hd gfu-hd--h4 gfu-hd--light _ttu _mb-1" }
const _hoisted_3 = { class: "gfu-media gfu-media--middle" }
const _hoisted_4 = { class: "gfu-media__body" }
const _hoisted_5 = {
  class: "gfu-hd gfu-hd--h4 gfu-hd--light",
  "data-qa": "project-stretch-goal:Target"
}
const _hoisted_6 = {
  class: "gfu-hd gfu-hd--h3 gfu-hd--light",
  "data-qa": "project-stretch-goal:Target"
}
const _hoisted_7 = {
  key: 1,
  class: "gfu-hd gfu-hd--h4 gfu-hd--light",
  "data-qa": "project-stretch-goal:Target"
}
const _hoisted_8 = { class: "gfu-project-summary-stretch-goal__progress" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_router_link = _resolveComponent("router-link")
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_progress_bar = _resolveComponent("progress-bar")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStretchGoalTitle), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      ($props.imageUrl)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: $options.route,
            class: "gfu-thumb _mr-3 _as-fs _pa-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_themed_image, {
                src: $props.imageUrl,
                alt: $props.name,
                width: "72",
                height: "72",
                class: "gfu-thumb__item"
              }, null, 8 /* PROPS */, ["src", "alt"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: $options.route,
          title: $props.name,
          class: "gfu-hd gfu-hd--h4 gfu-hd--decorative gfu-link gfu-link--nofx _line-clamp _line-clamp-2",
          "data-qa": "project-stretch-goal-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to", "title"]),
        ($options.isBackedFundsType)
          ? (_openBlock(), _createBlock(_component_display_currency_value, { key: 0 }, {
              "tooltip-content": _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectHome.ProjectApproximateCurrencyConversionTooltip, _ctx.$format($props.targetValue, 'C0'))), 1 /* TEXT */)
              ]),
              content: _withCtx(({ displayCurrency }) => [
                _createElementVNode("span", _hoisted_5, _toDisplayString($options.unlocksAtText(displayCurrency.symbol, displayCurrency.relativeFactor)), 1 /* TEXT */)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString($options.unlocksAtText()), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($options.unlocksAtText()), 1 /* TEXT */)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_progress_bar, {
            value: $props.value,
            max: $props.targetValue,
            class: "gfu-project-summary-stretch-goal__bar",
            "progression-class": "gfu-progress-bar__progression--accent gfu-progress-bar--animated"
          }, null, 8 /* PROPS */, ["value", "max"]),
          _createVNode(_component_base_icon, {
            name: "lock",
            class: "gfu-project-summary-stretch-goal__icon"
          })
        ])
      ])
    ])
  ]))
}